/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_SelfhostInputs */

const en_mk_cmp_r_selfhost = /** @type {(inputs: Mk_Cmp_R_SelfhostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can be self-hosted`)
};

const id_mk_cmp_r_selfhost = /** @type {(inputs: Mk_Cmp_R_SelfhostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dipasang di server sendiri`)
};

/**
* | output |
* | --- |
* | "Can be self-hosted" |
*
* @param {Mk_Cmp_R_SelfhostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_selfhost = /** @type {((inputs?: Mk_Cmp_R_SelfhostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_SelfhostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_selfhost(inputs)
	return en_mk_cmp_r_selfhost(inputs)
});